import type { ProformInvoice } from '@eliadmin/core/src/api/proform/proform-types';
import { Badge } from '@eliadmin/core/src/components/ui/badge';

export type ProfileInvoiceStatusProps = {
  invoice: ProformInvoice;
};

export function getInvoiceStatus(invoice: ProformInvoice) {
  switch (invoice.uhrazeno) {
    case '0':
      return { status: 'Neuhrazeno', colorClass: 'bg-red-500 text-white' };
    case '1':
      return { status: 'Částečně uhrazeno', colorClass: 'bg-yellow-500 text-black' };
    case '2':
      return { status: 'Uhrazeno', colorClass: 'bg-green-500 text-white' };
    case '3':
      return { status: 'Přeplaceno', colorClass: 'bg-blue-500 text-white' };
    default:
      return { status: 'Neznámý', colorClass: 'bg-gray-500 text-white' };
  }
}

export function ProfileInvoiceStatus(props: ProfileInvoiceStatusProps) {
  const status = getInvoiceStatus(props.invoice);

  return (
    <Badge className={`whitespace-nowrap text-center text-sm ${status.colorClass}`}>
      {status.status}
    </Badge>
  );
}
